import { render, staticRenderFns } from "./MetricasMedico2.vue?vue&type=template&id=3b461934"
import script from "./MetricasMedico2.vue?vue&type=script&lang=js"
export * from "./MetricasMedico2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports